export const iconMapper = status => {
    switch (status) {
        case 'SUCCESS':
		case 'PARTIAL_SUCCESS':
		case 'PROCESSED':
            return 'check-circle'
        case 'FAILED':
		case 'PROCESSING_ERROR':
		case 'PENDING_SIGNATURE ERROR_FILE':
		case 'UNKNOWN':
		case 'ERROR':
		case 'ERROR_FILE':
		case 'INVALID':
		case 'REVERSED':
            return 'error'
        default:
            return 'clock'
    }
}

export const iconColorMapper = status => {
    switch (status) {
        case 'SUCCESS':
		case 'PARTIAL_SUCCESS':
		case 'PROCESSED':
            return 'positive'
        case 'FAILED':
		case 'PROCESSING_ERROR':
		case 'PENDING_SIGNATURE ERROR_FILE':
		case 'UNKNOWN':
		case 'ERROR':
		case 'ERROR_FILE':
		case 'INVALID':
		case 'REVERSED':
            return 'negative'
        default:
            return 'warning'
    }
}

export const colorStatusMapperModal = status => {
    switch (status) {
        case 'SUCCESS':
		case 'PARTIAL_SUCCESS':
		case 'PROCESSED':
            return 'var(--positive)'
        case 'FAILED':
		case 'PROCESSING_ERROR':
		case 'PENDING_SIGNATURE ERROR_FILE':
		case 'UNKNOWN':
		case 'ERROR':
		case 'ERROR_FILE':
		case 'INVALID':
		case 'REVERSED':
            return 'var(--negative)'
        default:
            return 'var(--warning)'
    }
}
